<template>
	<div>
		
		
		<v-form ref="subscription_plan_form"  lazy-validation @submit.prevent="addAgent()">
			<v-row justify="start" class="custome-form">
				<v-col cols="6" md="4">
					<p class="sub-title-text-dark">
						{{$lang.SUBSCRIBER_DETAILS}}
					</p>
					<div>
						<label>{{$lang.SELECT_WHOLESALER}}</label>
						<wholesaler-select-box :wholesaler="form.wholesaler" @update-wholesaler="getWholesaler" />
					</div>
					<div>
						<label>{{$lang.PLAN}}</label>
						<plan-select-box @update-plan="getSubscriptionPlan"/>
					</div>
					<div>
						<label>{{$lang.PAYMENT_METHODS}}</label>
						<v-select
						v-model="form.payment_mode"
						:items="payment_methods_option"
						:placeholder="$lang.METHOD"
						outlined
						dense
						>
					</v-select>
				</div>
				<div v-if="form.payment_mode==$keys.OPTION_NEFT">
					<label>{{$lang.NEFT_TRANSACTION_ID}}</label>
					<v-text-field
					:placeholder="$lang.NEFT_TRANSACTION_ID"
					v-model="form.neft_ref_no"
					single-line
					outlined
					dense
					:rules="$rules.NEFT_TRANSACTION_ID"
					:maxlength="25"
					></v-text-field>
				</div>
				<div v-if="form.payment_mode==$keys.OPTION_CHEQUE">
					<label>{{$lang.CHEQUE_NUMBER}}</label>
					<v-text-field
					:placeholder="$lang.CHEQUE_NUMBER"
					v-model="form.cheque_number"
					single-line
					outlined
					dense
					:rules="$rules.CHEQUE_NUMBER"
					:maxlength="25"
					></v-text-field>
				</div>
				<div class="mt-2">
					<v-btn color="primary" @click="AddSubscriptionPlan" :loading="btn_loading">
						<b>{{$lang.CONTINUE}}</b>
					</v-btn>
				</div>
			</v-col>
			<v-col cols="6" md="1" class="border-r">
			</v-col>
			<v-col cols="6" md="4" class="pl-5">
				<div>
					<p class="sub-title-text-dark mb-2"> {{$lang.SUMMARY}}</p>

					<v-row justify="start" class="custome-form">
						<v-col cols="6" md="6" class="py-1">
							<label class="fs-14">{{$lang.WHOLESALER}}</label>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<p v-if="form.wholesaler" class="secondary-text">{{form.wholesaler.firm_name}}</p>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<label class="fs-14">{{$lang.PLAN}}</label>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<p v-if="form.plan" class="secondary-text">{{form.plan.name}}</p>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<label class="fs-14">{{$lang.PLAN_TYPE}}</label>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<p v-if="form.plan" class="secondary-text">{{form.plan.plan_type}}</p>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<label class="fs-14"> {{$lang.AMOUNT}}</label>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<p v-if="form.plan" class="secondary-text">{{form.plan.price}}</p>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<label class="fs-14"> {{$lang.GST_TEXT}}({{form.plan.gst_percent}}%)</label>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<p v-if="form.plan" class="secondary-text">{{form.plan.payable_amount-form.plan.price}}.00</p>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<label class="fs-14"> {{$lang.TOTAL_AMOUNT}}</label>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<p v-if="form.plan" class="secondary-text">{{form.plan.payable_amount}}</p>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<label class="fs-14">{{$lang.NUMBER_OF_DAYS}}</label>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<p v-if="form.plan" class="secondary-text">{{form.plan.validity}} {{$lang.DAYS}}</p>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<label class="fs-14">{{$lang.NUMBER_OF_SHIPMENT}}</label>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<p v-if="form.plan" class="secondary-text">{{form.plan.shipment_count}}</p>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<label class="fs-14">{{$lang.PAYMENT_METHODS}}</label>
						</v-col>
						<v-col cols="6" md="6" class="py-1">
							<p  class="secondary-text">{{form.payment_mode}}</p>
						</v-col>

						<v-col cols="6" md="6" class="py-1" v-if="form.payment_mode==$keys.OPTION_CHEQUE">
							<label class="fs-14">{{$lang.CHEQUE_NUMBER}}</label>
						</v-col>
						<v-col cols="6" md="6" v-if="form.payment_mode==$keys.OPTION_CHEQUE">
							<p  class="secondary-text">{{form.cheque_number}}</p>
						</v-col>
						<v-col cols="6" md="6" class="py-1" v-if="form.payment_mode==$keys.OPTION_NEFT">
							<label class="fs-14">{{$lang.NEFT_TRANSACTION_ID}}</label>
						</v-col>
						<v-col cols="6" md="6" v-if="form.payment_mode==$keys.OPTION_NEFT">
							<p  class="secondary-text">{{form.neft_ref_no}}</p>
						</v-col>
					</v-row>
				</div>
			</v-col>
		</v-row>
	</v-form>
	<!--  payment link dialog -->

	<payment-link-dialog :dialog="dialog" :url="url"/>
</div>
</template>

<script>
export default {
	components:{
		WholesalerSelectBox: () => import('@/components/common-components/WholesalerSelectBox.vue'),
		PlanSelectBox: () => import('@/components/common-components/PlanSelectBox.vue'),
		PaymentLinkDialog: () => import('./child/PaymentLinkDialog.vue'),
	},
	data(){
		return{
			payment_methods_option:[
			"Cheque",
			"NEFT/IMPS"],

			btn_loading:false,
			is_edit:false,
			subscription_plan_id:"",
			subscription_type_option:['Credit','Cash and Credit'],
			form:{
				wholesaler:"", 
				plan:"",
				cheque_number:"",
				neft_ref_no:"",
				payment_mode:"Cheque", 
			},
			dialog:{
				flag:false
			},
			url:"",
		}
	},
	created(){
		/*  show and hide the back btn*/
		if(this.$route.params.subscription_plan_id){
			this.subscription_plan_id= this.decrypt(this.$route.params.subscription_plan_id)
			this.is_edit=true
			this.getSubscriptionPlanDetails()

		}
	},
	methods:{
		getWholesaler(wholesaler){
			this.form.wholesaler=wholesaler
		},
		getSubscriptionPlan(plan){
			this.form.plan=plan
			if (plan.plan_type==this.$keys.ADDON_PLAN){
				this.payment_methods_option=["Cheque","NEFT/IMPS","Paytm"]
			}
			this.form.payment_mode=""
		},
		/* fetch wholesaler details */ 
		getSubscriptionPlanDetails(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={
				id:this.subscription_plan_id,
			};

			const successHandler = (response) => {
				if (response.data.success){
					self.form=response.data.data
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
				
			};
			self.request_GET( self,self.$urls.SUBSCRIPTION_PLAN_DETAILS,params,successHandler,null,null,finallyHandler)

		},
		/* Add Edit subscription_plan_form*/
		AddSubscriptionPlan(){
			const self=this
			if (this.$refs.subscription_plan_form.validate()==false)
				return false

			self.btn_loading=true
			var	form = new FormData();

			form.append("wholesaler_id",self.form.wholesaler.wholesaler_id);
			form.append("id",self.form.plan.id);
			form.append("payment_mode",self.form.payment_mode);
			form.append("neft_imps_id",self.form.neft_ref_no);
			if(this.form.payment_mode==this.$keys.OPTION_NEFT)
				form.append("neft_imps_id",self.form.neft_ref_no);
			else
				form.append("cheque_id",self.form.cheque_number);

			let url=self.$urls.GET_DIRECT_SUBSCRIPTION
			if(this.form.plan.plan_type==this.$keys.ADDON_PLAN)
				url=self.$urls.PURCHASE_ADDON_PLAN


			const successHandler = (response) => {
				if(response.data.success)
					if(this.form.plan.plan_type==this.$keys.ADDON_PLAN && self.form.payment_mode=='Paytm'){
						self.url=location.host+'/subscription-payment-page/?order_id='+response.data.order_id
						self.dialog.flag=true
					}
					else
						this.$router.push({name:"user-subscriptions"})
				};
				const finallyHandler = () => {
					self.btn_loading=false
				};
				this.request_POST(self,url,form,successHandler,null,null,finallyHandler)

			},

		}	

	}
	</script>